import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { InventoryOnHandReport } from '../models/inventory-on-hand-reports';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InventoryOnHandReportService {
  protected basePath = '/';

  constructor(protected httpClient: HttpClient,
    private authService: AuthService,) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  getAllInventoryOnHandReports(): Observable<InventoryOnHandReport[]> {
    return this.httpClient.get<InventoryOnHandReport[]>(`${this.basePath}/api/stemilt/raw-inventory`);
  }

  getAllInventoryOnHandReportsFromSteamilt(): Observable<InventoryOnHandReport[]> {
    return this.httpClient.get<InventoryOnHandReport[]>(`${this.basePath}/api/stemilt/inventory-on-hand-reports`
    );
  }

  syncInventory(): Observable<any> {
    return this.httpClient.post(`${this.basePath}/api/stemilt/sync-inventory?tenant=STMLT5202`, {});
  }

}
